export default __webpack_public_path__ + "static/media/Camion Box2Home2.b12d7909.svg";